import { getSrcs, imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import CategoryTags from '@stories/Components/Misc/CategoryTags/CategoryTags';
import * as React from 'react';
import S from './MarketplaceCard.styles';
const MarketplaceCard = (props) => {
    const srcs = getSrcs(props.image, 504, 375, 4, 504 / 280);
    const sizes = `${until(Device.TabletSmall)} 100vw, ${until(Device.Desktop)} 50vw, ${until(Device.ActualDesktop)} 33vw, 504px`;
    return (React.createElement(S.Container, { href: props.cta.url, target: props.cta.target },
        React.createElement(S.ImageWrapper, null,
            srcs.srcSet && (React.createElement(S.Image, { alt: props.image.altText, loading: "lazy", role: !props.image.altText ? 'presentation' : undefined, sizes: sizes, src: srcs.src, srcSet: srcs.srcSet })),
            props.categories && React.createElement(CategoryTags, { items: props.categories }),
            props.companyLogo && (React.createElement(S.CompanyLogo, { src: imageUrl(props.companyLogo, { width: 142 }), alt: props.companyLogo.altText, loading: "lazy", role: !props.companyLogo.altText ? 'presentation' : undefined }))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Title, null, props.name),
            React.createElement(S.Summary, { dangerouslySetInnerHTML: { __html: props.summary } }),
            React.createElement(FakeButton, { buttonType: "solid" }, props.cta.text))));
};
export default MarketplaceCard;
